// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";

import DropdownController from "./dropdown_controller";
application.register("dropdown", DropdownController);

import MobileMenuController from "./mobile_menu_controller";
application.register("mobile-menu", MobileMenuController);

import ReportPollingController from "./report_polling_controller";
application.register("report-polling", ReportPollingController);

import PresentationController from "./presentation_controller";
application.register("presentation", PresentationController);

import GeneratingStepsController from "./generating_steps_controller";
application.register("generating-steps", GeneratingStepsController);

import AccountConnectionsController from "./account_connections_controller";
application.register("account-connections", AccountConnectionsController);

import ReportPeriodController from "./report_period_controller";
application.register("report-period", ReportPeriodController);

import TypewriterController from "./typewriter_controller";
application.register("typewriter", TypewriterController);
import FlashController from "./flash_controller";
application.register("flash", FlashController);

import ScaleController from "./scale_controller";
application.register("scale", ScaleController);

import PhotoOrientationController from "./photo_orientation_controller";
application.register("photo-orientation", PhotoOrientationController);

import FontPairingController from "./font_pairing_controller";
application.register("font-pairing", FontPairingController);

import ContentsController from "./contents_controller";
application.register("contents", ContentsController);
